/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  news: [],
  latest: [],
  careers: {},
  mediablocks: {},
  textblocks: {},
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getNews: (state) => state.news,
  getLatestNews: (state) => state.latest
};
// Actions
const actions = {
  requestAllNews({commit}){
    return new Promise((resolve, reject) => {
      axios({
          url: 'taktnews',
          method: 'GET',
          headers: {'Cache-Control': 'no-cache'}
        })
        .then(resp => {
          commit('set_news', resp.data.data);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  requestLatestNews({commit}){
    return new Promise((resolve, reject) => {
      axios({
          url: 'taktnews?latest=true',
          method: 'GET',
          headers: {'Cache-Control': 'no-cache'}
        })
        .then(resp => {
          commit('set_latest', resp.data.data);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  createTaktNews({commit}, payload){
    axios({
      url: 'taktnews',
      method: 'POST',
      data: payload
    })
    .then(resp => {
      commit('append_news', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateTaktNews({commit}, payload){
    axios({
      url: 'taktnews/' + payload.id,
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_news', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  requestCareers({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'categories/0/careers',
        method: 'GET'
      })
      .then(resp => {
        commit('set_careers', resp.data.data.articles);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  requestJob({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: `categories/${payload.category_id}/articles/${payload.article_id}?show=showWithEntitiesNormalized`,
        method: 'GET'
      })
      .then(resp => {
        commit('insert_article', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_news(state, news){
    state.news = [...news];
  },
  set_careers(state, careers){
    for (let i = 0; i < careers.length; i++) {
      state.careers[careers[i].id] = careers[i];
    }
  },
  insert_article(state, payload){
    
    if (state.careers[payload.articles[0].id]) {
      Object.assign(state.careers[payload.articles[0].id], payload.articles[0]);
    } else {
      state.careers[payload.articles[0].id] = payload.articles[0];
    }

    for (let i = 0; i < payload.mediablocks.length; i++) {
      state.mediablocks[payload.mediablocks[i].id] = payload.mediablocks[i];
    }

    for (let j = 0; j < payload.textblocks.length; j++) {
      state.textblocks[payload.textblocks[j].id] = payload.textblocks[j];
    }

  },
  append_news(state, news){
    state.news.push(news);
  },
  update_news(state, payload){
    const index = state.news.findIndex(function(item) {
      return item.id == payload.id;
    });
    Object.assign(state.news[index], payload.update);
  },
  set_latest(state, latest){
    state.latest = [...latest];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
